module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C134"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("ILLUSTRATIONS")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "C136"
  }, [_c('strong', [_vm._v("Figures")])])]), _c('p', {
    staticClass: "C135"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09_1__The_L#id_336"
    }
  }, [_vm._v("1.1. Categorization of political systems")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#id_337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. Effect of bias period on winners’ margin of victory")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#id_338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1. Effect of monopoly period on spending patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#page_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1. Monopoly periods for cities with certain start and end dates")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#id_339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2. Monopoly hazard rate")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#id_340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.3. Hazard ratios, economic diversity (machine)")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#id_341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.4. Hazard ratios, economic diversity (reform)")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#id_342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.5. Hazard ratios, % nonwhite")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#id_343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.6. Hazard ratios, % employed (machine)")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#id_344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.7. Hazard ratios, % employed (reform)")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('strong', [_vm._v("Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1__The_L#id_345"
    }
  }, [_vm._v("1.1. Biasing strategies")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_3__Coord#id_346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1. Country of origin for Chicago population, 1930")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_3__Coord#id_347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2. Ethnic Democratic votes")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_3__Coord#id_348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3. Deliverability of Chicago ethnic wards, 1935, 1939, 1947")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_3__Coord#id_349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4. Deliverability of San Jose neighborhoods, 1938–62")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_3__Coord#id_350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5. Reform support by neighborhoods")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_3__Coord#id_351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.6. Reform monopoly success")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#id_352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. Monopoly cities used in electoral analyses")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#id_353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2. Competition during bias period")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#id_354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3. Bias effect on incumbents’ decision to run for reelection")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#id_355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4. Incumbency advantage during bias period")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#id_356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.5. Competition during bias period, controlling for city demographics")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#id_357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.6. Incumbency advantage during bias period, controlling for city demographics")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#id_358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.7. Political context of monopoly")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.8. Factors affecting monopoly emergence")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#page_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1. Turnout during bias periods")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#id_359",
      "id": "page_x",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2. Effect of bias on turnout of eligible voters")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#id_360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3. Turnout varies with regime membership")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#id_361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.4. The effect of bias on turnout of eligible voters, controlling for city demographics")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#id_362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.5. Chicago turnout by ward")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.6. Effect of monopoly on targeted benefits")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#id_363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.7. Irish government employment in machine cities")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#id_370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1. Factors contributing to monopoly decline")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#id_364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2. Weak monopolies spread benefits")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix#id_368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A1. Cities with no evidence of machine or reform monopoly in the twentieth century")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix#id_365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A2. Cities with evidence of dominance during the twentieth century, with unclear start and/or end dates")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix#page_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A3. Cities with evidence of dominance during the twentieth century, with clear start and end dates")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix#id_366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A4. Monopoly cities used in electoral analyses")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix#page_244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A5. Summary statistics, election-level data set")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix#id_367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A6. Summary statistics, candidate-level data set (incumbents only)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3742629d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_List_of.vue
// module id = 69
// module chunks = 0